import * as moment from 'moment';

export class LoadHandover {

  public id: string;
  public loadUuid: string;
  public loadId: string;
  public loadNumber: string;
  public shipmentNumbers: string[];
  public salesOrderNumber: string[];
  public releasedByVehicle: string;
  public takenByVehicle: string;
  public releasedAt: moment.Moment;
  public takenAt: moment.Moment;
  public releasedLatitude: number;
  public releasedLongitude: number;
  public takenLatitude: number;
  public takenLongitude: number;
  public isActive: boolean;

  public isOld = false;
  public releasedAddress: string;
  public takenAddress: string;
  public distanceBetweenReleaseAndTake: number;
  public tripId: string;

  static fromDto(h: any): LoadHandover {
    if (!h) {
      return null;
    }

    const loadHandover = new LoadHandover();

    loadHandover.id                            = h.id;
    loadHandover.loadUuid                      = h.load_uuid;
    loadHandover.loadId                        = h.load_id;
    loadHandover.loadNumber                    = h.load_number;
    loadHandover.shipmentNumbers               = h.shipment_numbers ? h.shipment_numbers : [];
    loadHandover.salesOrderNumber              = h.sales_order_numbers ? h.sales_order_numbers : [];
    loadHandover.releasedByVehicle             = h.released_by_vehicle;
    loadHandover.takenByVehicle                = h.taken_by_vehicle;
    loadHandover.releasedAt                    = h.released_at ? moment(h.released_at) : null;
    loadHandover.takenAt                       = h.taken_at ? moment(h.taken_at) : null;
    loadHandover.releasedLatitude              = h.released_latitude;
    loadHandover.releasedLongitude             = h.released_longitude;
    loadHandover.takenLatitude                 = h.taken_latitude;
    loadHandover.takenLongitude                = h.taken_longitude;
    loadHandover.isActive                      = h.active;
    loadHandover.distanceBetweenReleaseAndTake = h.distance_between_release_and_take;

    loadHandover.isOld = loadHandover.releasedAt.isBefore(moment().subtract(1, 'week'));

    return loadHandover;
  }
}
